/** @format */

import { FilterType } from '../../model';
import { createSelector } from '@ngrx/store';
import { selectProductReviewState } from './product-reviews.selector';

/**
 * @description
 * Handles each different scenario for product Reviews functionality
 */

export const selectSelectedTag = createSelector(
	selectProductReviewState,
	(state) => state.productReviewsFilterState.selectedTag
);

export const selectReviewFilters = createSelector(
	selectProductReviewState,
	(state) => state.productReviewsFilterState.filters
);

export const selectSearchFilter = createSelector(
	selectProductReviewState,
	(state) => state.productReviewsFilterState.search
);

export const selectSortFilter = createSelector(
	selectProductReviewState,
	(state) => state.productReviewsFilterState.sort
);

export const selectRatingFilters = createSelector(selectReviewFilters, (filters) => {
	if (Array.isArray(filters)) {
		return filters.filter((filter) => filter.type === FilterType.RATING);
	}
	return [];
});
